import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJson from './locale/en.json';
import deJson from './locale/de.json';
import { BRAND } from './brand/brand';

i18n.use(initReactI18next).init({
    resources: {
        en: { ...enJson },
        de: { ...deJson },
    },
    lng: localStorage.getItem('i18nextLng') || 'de', // Use stored language or default to 'de'
    fallbackLng: 'de',
    debug: true, // Enable debug logging
    interpolation: {
        escapeValue: false,
        // Der Markenname steht in den Übersetzungen als {{brandName}} und wird
        // vom Host abgeleitet (siehe src/brand/brand.ts). Als defaultVariable
        // muss ihn keine Aufrufstelle mitgeben.
        defaultVariables: {
            brandName: BRAND.name,
            appName: BRAND.appName,
        },
    },
});

/**
 * Keep `<html lang>` in step with the active language.
 *
 * index.html ships `lang="en"` and nothing ever corrected it, so a German UI
 * claimed to be English. Screen readers pick their pronunciation from this, the
 * browser offers to translate a page that needs no translating, and spell
 * checking runs against the wrong dictionary.
 */
const applyDocumentLanguage = (language: string) => {
    if (typeof document !== 'undefined' && language) {
        document.documentElement.lang = language.split('-')[0];
    }
};

applyDocumentLanguage(i18n.language);
i18n.on('languageChanged', applyDocumentLanguage);

// Add debug logging
console.log('🌍 i18next initialized with lng:', i18n.language);
console.log('🌍 i18next resolvedLanguage:', i18n.resolvedLanguage);
console.log('🌍 localStorage i18nextLng:', localStorage.getItem('i18nextLng'));